import { createSlice } from '@reduxjs/toolkit';

import { ERROR, PRICE_SELECTED, QUOTED, QUOTING } from 'shared/data/quoteSteps';
import { doAddToCart } from 'shared/thunks';
import { shouldForceRequote } from 'shared/utils/shouldForceRequote';

import initialState from 'us_pcb_assembly/data/initialState';
import { doEmailQuote, doQuote } from 'us_pcb_assembly/store/thunks';

const usAssemblySlice = createSlice({
  name: 'usAssemblySlice',
  initialState: {
    ...initialState,
  },
  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload;
      switch (name) {
        case 'qty1':
          state.parameters.quantities[0] = value;
          break;
        case 'qty2':
          state.parameters.quantities[1] = value;
          break;
        case 'qty3':
          state.parameters.quantities[2] = value;
          break;
        case 'qty4':
          state.parameters.quantities[3] = value;
          break;
        default:
          state.parameters[name] = value;
      }

      state.parametersChanged = shouldForceRequote(name);
    },
    priceSelected(state, action) {
      const {
        row_selected,
        column_selected,
        supplier,
        currentVariant,
      } = action.payload;
      state.parameters.row_selected = row_selected;
      state.parameters.column_selected = column_selected;
      state.parameters.supplier_selected = supplier;
      state.currentVariant = currentVariant;

      state.quoteStep = PRICE_SELECTED;
    },
    updateValidatorFlag(state) {
      state.validatorFlag = !state.validatorFlag;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(doQuote.pending, (state) => {
        state.loading = true;
        state.quoteStep = QUOTING;
      })
      .addCase(doQuote.fulfilled, (state, action) => {
        const quote = action.payload;
        state.loading = false;
        state.parametersChanged = false;

        state.parameters.product_quote_number = quote.number;
        state.parameters.row_selected = '';
        state.parameters.column_selected = '';
        state.parameters.supplier_selected = '';

        if (!quote || !quote.line_items) {
          state.quoteStep = ERROR;
        } else {
          state.quoteStep = QUOTED;
        }

        state.quote = quote;
      })
      .addCase(doQuote.rejected, (state) => {
        state.loading = false;
        state.quote = {};
        state.quoteStep = ERROR;
      })
      .addCase(doEmailQuote.pending, (state) => {
        state.loading = true;
      })
      .addCase(doEmailQuote.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(doEmailQuote.rejected, (state) => {
        state.loading = false;
      })
      .addCase(doAddToCart.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(doAddToCart.fulfilled, (state) => {
        state.addingToCart = true;
      })
      .addCase(doAddToCart.rejected, (state) => {
        state.addingToCart = false;
      });
  },
});

export const {
  changeParameter,
  priceSelected,
  updateValidatorFlag,
  showValidatorErrorMessages,
  hideValidatorErrorMessages,
  addErrors,
  dismissErrors,
} = usAssemblySlice.actions;

export default usAssemblySlice.reducer;
